/**
 * Browser-safe copy of the canonical contract fixture. A parity test compares
 * this object with createCityCordonRingSpecification(), keeping the Three.js
 * reference preview exact without shipping the validation library to clients.
 */
export const CITY_CORDON_PREVIEW_SPECIFICATION = Object.freeze({
  schemaVersion: "worldloom.radial-structure.v1",
  id: "city_cordon_ring_segmented",
  label: "12-Piece City Cordon Ring",
  category: "cordon_ring",
  status: "design_specification",
  profile: "city_cordon_ring_12_piece_v1",
  summary: "Closed 12-sided cordon ring assembled from one reusable straight static-mesh segment.",
  segment: {
    count: 12,
    angularSpacingDeg: 30,
    centrelineLengthM: 402,
    radialDepthM: 15,
    innerFaceLengthM: 397.981,
    outerFaceLengthM: 406.019,
    endMitreDeg: 15,
    baseZM: -6,
    topZM: 12,
    totalHeightM: 18,
    localTopVerticesM: {
      innerLeft: { x: -198.990381, y: -7.5 },
      innerRight: { x: 198.990381, y: -7.5 },
      outerRight: { x: 203.009619, y: 7.5 },
      outerLeft: { x: -203.009619, y: 7.5 },
    },
    coordinateFrame: {
      tangentialAxis: "x",
      outwardAxis: "y",
      upwardAxis: "z",
      pivot: "segment_centreline_centre",
      metersToCentimeters: 100,
      importScale: 1,
    },
  },
  assembly: {
    midpointRadiusM: 750.142,
    placementRadiusCm: 75_014.221,
    oppositeFlatDiameterM: 1_500.284,
    startAngleDeg: 0,
    yawOffsetDeg: -90,
    scale: { x: 1, y: 1, z: 1 },
    actorLabelPrefix: "CityCordonRing_",
    outlinerFolder: "Arena/City/Cordon",
    actorTag: "CordonRoad",
  },
  unreal: {
    staticMeshPath: "/Game/Arena/City/SM_CityCordonRingSegment_A",
    legacyMeshPath: "/Game/Arena/City/SM_CityCordonRing_A",
    materialSlots: { CordonStructure: 0, CordonFloor: 1 },
    materials: {
      CordonStructure: "/Game/Arena/City/M_CityCordonStructure",
      CordonFloor: "/Game/Arena/City/M_CityCordonFloor",
    },
    bakeAsStaticMesh: true,
    reuseSingleMesh: true,
    preserveConnectionPlanes: true,
    outwardFacingNormals: true,
    continuousUvScale: true,
    collision: "walkable_blocking",
  },
  acceptance: {
    closedRegularRing: true,
    seamToleranceCm: 1,
    rejectGaps: true,
    rejectOverlaps: true,
    rejectInvertedNormals: true,
    rejectCollisionDiscontinuities: true,
  },
});
